// extracted by mini-css-extract-plugin
module.exports = {"active":"navbar-module--active--2vLf3","container":"navbar-module--container--1XdJp","homebtn":"navbar-module--homebtn--1tFOX","pages":"navbar-module--pages--V2gj8"};